import Modal from "@atomaro/ui-kit/components/Modal/Modal";
import { FC } from "react";
import { RentHiveFooter, RentHiveHeaderRow, RentHivePopup } from "./style";
import { ModalContent } from "./ModalContent";
import { SharedHive } from "entities/hives/model/types";
import { Button } from "@atomaro/ui-kit";
import { COLORS } from "shared/consts";

export type RentHiveModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onShare: () => void;
  onDelShare: () => void;
  findedShared: SharedHive | null;
  successShare: "" | "success";
  isLoading: boolean;
};

export const RentHiveModal: FC<RentHiveModalProps> = ({
  isOpen,
  onClose,
  onDelShare,
  onShare,
  findedShared,
  successShare,
  isLoading,
}) => {
  return (
    <Modal
      isOpen={isOpen}
      centered
      style={{
        padding: 0,
        maxWidth: "360px",
        width: "360px",
        maxHeight: "auto",
      }}
      onClickOverlay={onClose}
    >
      <RentHivePopup>
        <RentHiveHeaderRow>
          {successShare === "success" ? (
            <h3>Улей успешно сдан в аренду</h3>
          ) : (
            <h3>Аренда улья</h3>
          )}
          <Button
            size="s"
            variant="outline"
            colorScheme="neutral"
            onClick={onClose}
            iconPrefix={
              <svg
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                style={{
                  fill: "none",
                }}
              >
                <rect
                  id="24 / Navigation / Close Large"
                  width="24.000000"
                  height="24.000000"
                  x="0.000000"
                  y="0.000000"
                />
                <path
                  id="Union"
                  d="M10.9401 12.0006L4.99902 17.9417L6.05968 19.0023L12.0008 13.0612L17.9418 19.0023L19.0025 17.9417L13.0614 12.0006L19.0025 6.0595L17.9418 4.99884L12.0008 10.9399L6.0597 4.99884L4.99904 6.0595L10.9401 12.0006Z"
                  fill={COLORS.FG.DEFAULT}
                  fillRule="evenodd"
                />
              </svg>
            }
          />
        </RentHiveHeaderRow>
        <ModalContent findedShared={findedShared} successShare={successShare} />
        <RentHiveFooter>
          {successShare === "success" ? (
            <Button
              size={"l"}
              colorScheme="accent"
              label="Отлично"
              style={{
                width: "100%",
              }}
              onClick={onClose}
            />
          ) : (
            <>
              <Button
                size={"l"}
                colorScheme="neutral"
                variant="ghost"
                label="Отмена"
                style={{
                  width: "100%",
                }}
                onClick={onClose}
              />
              <Button
                size={"l"}
                colorScheme="accent"
                label={`${
                  findedShared &&
                  !findedShared.reservationId &&
                  successShare === ""
                    ? "Снять с аренды"
                    : findedShared?.reservationId
                      ? "Улей арендован"
                      : "Сдать в аренду"
                }`}
                style={{
                  width: "100%",
                }}
                onClick={() => {
                  return findedShared &&
                    !findedShared.reservationId &&
                    successShare === ""
                    ? onDelShare()
                    : onShare();
                }}
                disabled={
                  (Boolean(findedShared?.reservationId) &&
                    successShare === "") ||
                  isLoading
                }
              />
            </>
          )}
        </RentHiveFooter>
      </RentHivePopup>
    </Modal>
  );
};
